import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, onRegistered, register } from 'firebase/messaging';

import {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_FIREBASE_APP_ID,
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    REACT_APP_FIREBASE_PROJECT_ID,
    REACT_APP_FIREBASE_VAPID_KEY,
} from '../app/app.config';

const firebaseConfig = {
    apiKey: REACT_APP_FIREBASE_API_KEY,
    authDomain: `${REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
    projectId: REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: REACT_APP_FIREBASE_APP_ID,
};

export const subscribeToPush = async (onFid: (fid: string) => void): Promise<void> => {
    if (!REACT_APP_FIREBASE_VAPID_KEY || !(await isSupported())) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const messaging = getMessaging(initializeApp(firebaseConfig));

    onRegistered(messaging, onFid);

    await register(messaging, { vapidKey: REACT_APP_FIREBASE_VAPID_KEY });
};
